  import { jsx as _jsx } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
/**
 * Render the final JSX of DialogBody
 */ export const renderDialogBody_unstable = (state)=>{
    assertSlots(state);
    // TODO Add additional slots in the appropriate place
    return /*#__PURE__*/ _jsx(state.root, {});
};
